
import { Component, OnDestroy } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { Subscription } from 'rxjs';
import { MatrixODCameraService } from '@shared/services/matrizOD-camera-service/matrix-od-camera.service';

@Component({
  selector: 'panel-matrix-od-camera',
  templateUrl: './panel-matrix-od-camera.component.html',
  styleUrls: ['./panel-matrix-od-camera.component.scss'],
})
export class PanelMatrixOdCameraComponent implements OnDestroy{
  Icon = Icon;

  ActiveCamera : any = undefined;
  DataCamera : any = undefined;
  Subscription1 : Subscription = undefined;
  Subscription2 : Subscription = undefined;
  formatDate : {start:string,end:string} = {start:'',end:''}

  constructor(
    private ODMatrixCamera: MatrixODCameraService,
  ) {
    this.Subscription1 = this.ODMatrixCamera.subjetdDataCamera$.subscribe((res : any) => {
      this.DataCamera = {...res};
      this.formatDate.start = this.DataCamera.timeStart;
      this.formatDate.end = this.DataCamera.timeEnd;
    })
    this.Subscription2 = this.ODMatrixCamera.dataCameraActive$.subscribe((res : any) => {
      this.ActiveCamera = res.values;
    })
  }

  ngOnDestroy() {
    if(this.Subscription1) {
      this.Subscription1.unsubscribe()
    }
    this.ODMatrixCamera.cameraDataSubjet.next(undefined)
    if(this.Subscription2) {
      this.Subscription2.unsubscribe()
    }
    this.ODMatrixCamera.cameraDataActive.next(undefined)
  }
}
